import { render, staticRenderFns } from "./AnnotationTermRow.vue?vue&type=template&id=4d70c288&scoped=true"
import script from "./AnnotationTermRow.vue?vue&type=script&lang=js"
export * from "./AnnotationTermRow.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTermRow.vue?vue&type=style&index=0&id=4d70c288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d70c288",
  null
  
)

export default component.exports